module.exports = __webpack_public_path__ + "static/media/logo.21fb223b.svg";